"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _icons = require("../../../static/icons/icons");

var _Icon = _interopRequireDefault(require("../../atoms/Icon"));

var _style = require("./style");

var Popup = function Popup(_ref) {
  var title = _ref.title,
      children = _ref.children,
      onClose = _ref.onClose,
      isOpen = _ref.isOpen,
      fatherOverflow = _ref.fatherOverflow,
      showClose = _ref.showClose;
  return _react["default"].createElement(_style.Background, {
    isOpen: isOpen,
    role: "link",
    onClick: onClose,
    onKeyPress: onClose,
    tabIndex: "0"
  }, _react["default"].createElement(_style.Global, {
    isOpen: isOpen
  }), _react["default"].createElement(_style.Container, {
    role: "link",
    onClick: function onClick(e) {
      e.stopPropagation();
    },
    onKeyPress: function onKeyPress(e) {
      e.stopPropagation();
    },
    tabIndex: "0"
  }, showClose && _react["default"].createElement(_style.CloseButton, null, _react["default"].createElement(_Icon["default"], {
    icon: _icons.ICONS.CLOSE,
    handleClick: onClose
  })), _react["default"].createElement(_style.Title, null, _react["default"].createElement("h2", null, title)), _react["default"].createElement(_style.Father, {
    fatherOverflow: fatherOverflow
  }, children)));
};

Popup.propTypes = {
  children: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].node), _propTypes["default"].node]).isRequired,
  title: _propTypes["default"].string.isRequired,
  fatherOverflow: _propTypes["default"].string,
  onClose: _propTypes["default"].func.isRequired,
  showClose: _propTypes["default"].bool,
  isOpen: _propTypes["default"].bool
};
Popup.defaultProps = {
  isOpen: false,
  showClose: true,
  fatherOverflow: 'visible'
};
var _default = Popup;
exports["default"] = _default;